// Centralized external configuration.
//
// Every external URL the app talks to is read from a build-time environment
// variable (REACT_APP_*), so nothing is hardcoded across the codebase.
// The defaults below preserve current production behaviour when no env var is
// provided. See docker-compose.yml / Dockerfile for how these are injected.

const trimTrailingSlash = (url) => (url || '').replace(/\/+$/, '');

// Ya no queda ningún webhook de n8n: crear contrato, subir contrato, subir
// firmado y subir factura los gestiona el backend en /api/collaborations/:id/...

// ===== Back-office (GTS) =====
export const ADMIN_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_ADMIN_BASE_URL || 'https://admin.latiendahome.com'
);

export const orderUrl = (orderId) =>
  `${ADMIN_BASE_URL}/gts/pedidos_ver.html?action=edit&oID=${orderId}`;

// ===== Public storefront =====
export const PUBLIC_SITE_URL = trimTrailingSlash(
  process.env.REACT_APP_PUBLIC_SITE_URL || 'https://www.latiendahome.com'
);

export const NEW_COLLABORATION_URL = `${PUBLIC_SITE_URL}/colaboraciones`;

// ===== Brand assets (CDN) =====
export const LOGO_URL =
  process.env.REACT_APP_LOGO_URL ||
  'https://latiendahome-cms.s3.eu-west-1.amazonaws.com/Logotipo_68d4113877.svg';

export const LOGO_LOGIN_URL =
  process.env.REACT_APP_LOGO_LOGIN_URL ||
  'https://latiendahome-cms.s3.eu-west-1.amazonaws.com/logo_home_6f0c62f340.png';
